<template lang="pug">
  hotsite-dcom
    .conteudo
      bloco.-nomargin.-softpadding.-fullheight
        //- HEADER
        header(slot="header")
          titulo.-withbar.-upper Legislação
        //- CONTENT
        .texto(slot="content" v-html="legislacoes" v-if="legislacoes")
        loading(slot="content" v-else)
        //- FOOTER
        footer(slot="footer")
          back-and-share
</template>

<script>
  import BackAndShare from 'COMPONENTS/BackAndShare'
  import Bloco from 'COMPONENTS/Bloco'
  import HotsiteDcom from 'PAGES/dcom/Base'
  import Loading from 'COMPONENTS/Loading'
  import Mensagem from 'COMPONENTS/Mensagem'
  import Titulo from 'COMPONENTS/ElementTitle'

  import ConteudoService from '../../../js/api/dcom/ConteudoService'

  export default {
    components: {
      BackAndShare,
      Bloco,
      HotsiteDcom,
      Loading,
      Mensagem,
      Titulo
    },
    data () {
      return {
        legislacoes: ''
      }
    },
    mounted () {
      ConteudoService.getSobreInicial('dcom', 'legislacao')
        .then(response => {
          this.legislacoes = response.data[0].acf.descricao
        })
    }
  }
</script>



// WEBPACK FOOTER //
// Legislacoes.vue?047e6049